//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../Motion/Motion.SelectFieldData.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"CarcassMass",0,"Expression",0],[1,"LateralDamping",0,"Expression",0],[0,"LateralEffects",1,0],[1,"LateralStiffness",0,"Expression",0],[1,"LongDamping",0,"Expression",0],[1,"LongStiffness",0,"Expression",0],[0,"LongitudinalEffects",1,0],[0,"RollMoment",1,0],[0,"UnloadingVerticalStiffness",1,"Motion.MotionFunction",0],[1,"UnloadingVerticalStiffnessProfile",0,"Motion.SelectFieldData",0],[0,"UnloadingVerticalStiffnessType",1,0],[0,"VerticalCarcassEffects",1,0],[1,"VerticalStiffnessTransVelocity",0,"Expression",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Motion.TirePropertyHighOrderParameters = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.TirePropertyHighOrderParameters";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.TirePropertyHighOrderParameters.UnloadingVertStiffType = Object.freeze({
    "Function" : "Function", "Profile" : "Profile"});

export default SPLM;